import { upsertResource } from '@dispatch/shared/services';
import { Resource, ResultStatus, UpsertResource } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';
import { useCompany } from '../company';

export const useUpsertResource = (
  resourceId: string,
  onSuccess: ({ success }: { success: boolean; message?: string }) => void
): {
  upsertResource: UpsertResource;
  upsertResourceError: unknown;
  upsertResourceStatus: ResultStatus;
} => {
  const client = useQueryClient();
  const { featureFlags } = useCompany();

  const { mutate, error, status } = useMutation(
    ['upsert-resource', resourceId],
    async (data: Resource) => {
      const payload: Resource = { ...data };

      if (featureFlags?.excludeCertsAndLicenses) {
        // ensure certs and licenses are not sent when the feature flag is enabled
        payload.selectedCertificationsAndLicenses = [];
      }

      return upsertResource(payload);
    },
    {
      onSuccess,
      onSettled: (response) => {
        if (response?.success && resourceId) {
          client.invalidateQueries(['resource', resourceId]);
          client.invalidateQueries('resource');
          client.invalidateQueries('resources');
        }
      },
    }
  );

  return {
    upsertResource: mutate,
    upsertResourceError: error,
    upsertResourceStatus: status as ResultStatus,
  };
};
